import { createRoot } from 'react-dom/client';
import Dashboard from "./settings/Components/Dashboard";
import { style } from './utils/icons';
import QueryPanel from './PluginSettings/General/QueryPanel';
import StylePanel from './PluginSettings/Style/StylePanel';
import SwipeLayoutPanel from './PluginSettings/General/SwipeLayoutPanel';
import StyleField from './PluginSettings/Style/StyleField';
import SettingPanel from './PluginSettings/General/SettingsPanel';
import GridLayoutPanel from './PluginSettings/General/GridLayoutPanel';

document.addEventListener('DOMContentLoaded', () => {
  const dashboardEl = document.getElementById('bpwsnbDashboard');

  const items = [
    {
      name: "settings",
      title: "Settings",
      description: "",
      Component: Setting,
    },
    {
      name: "query",
      title: "Query",
      description: "",
      Component: Query,
    },
    {
      name: "swipelayout",
      title: "Swipe Layout",
      Component: SwipeLayout,
    },
    {
      name: "gridlayout",
      title: "Grid Layout",
      Component: GridLayout,
    },
    {
      name: "style",
      title: "Style",
      description: "",
      logo: style,
      Component: StyleTest,
      children: [
        {
          name: "button",
          title: "Button",
          Component: button,
        }
      ]
    }
  ];

  if (dashboardEl) {
    const pageCreate = async (data) => {
      const { route } = data || {};
      try {
        const serializedData = JSON.stringify(data); // Serialize data to JSON
        await fetch(`${wcCategories?.ajaxUrl}?action=bpwsnb_create_page&nonce=${wcCategories?.nonce}&route=${route}&data=${encodeURIComponent(serializedData)}`);
        return true;
      } catch (error) {
        console.error('Error:', error);
      }
    }

    createRoot(dashboardEl).render(<Dashboard name='bpwsnbSwipeNBuy' items={items} saveCallback={pageCreate} />);
  }
});

// Setting Panel
const Setting = ({ data, setData }) => {
  return <SettingPanel data={data} setData={setData} />
}

const Query = ({ data, setData }) => {
  return <QueryPanel data={data} setData={setData} />
}

// Style Panel 

const StyleTest = ({ data, setData }) => {
  return <StylePanel data={data} setData={setData} />
}


const SwipeLayout = ({ data, setData }) => {
  return <SwipeLayoutPanel data={data} setData={setData} />
}

const GridLayout = ({ data, setData }) => {
  return <GridLayoutPanel data={data} setData={setData} />
}

const button = ({ data, setData }) => {
  return <StyleField data={data} setData={setData} />
}
